import { render, staticRenderFns } from "./List.vue?vue&type=template&id=29c777c2&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QPageSticky,QBtn,QTable,QTr,QTd,QTooltip,QInput,QIcon,QDialog,QCard,QCardSection,QAvatar,QSelect,QCardActions,QColor,ClosePopup} from 'quasar'
component.options.components = Object.assign({QPage,QPageSticky,QBtn,QTable,QTr,QTd,QTooltip,QInput,QIcon,QDialog,QCard,QCardSection,QAvatar,QSelect,QCardActions,QColor}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
